var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMultiplicationFactors = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  fillRule: "evenodd",
  d: "M25 7H8v19h17V7ZM7 6v21h19V6H7Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  fillRule: "evenodd",
  d: "M22 10H11v3h11v-3ZM10 9v5h13V9H10Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C7CDDD",
  d: "M11 17h3v3h-3v-3ZM11 15h11v1H11v-1ZM11 21h3v3h-3v-3ZM15 17h3v3h-3v-3ZM15 21h3v3h-3v-3ZM19 17h3v3h-3v-3ZM19 21h3v3h-3v-3Z"
})));
export { SvgIcMultiplicationFactors as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNSA3SDhWMjZIMjVWN1pNNyA2VjI3SDI2VjZIN1oiIGZpbGw9IiNDN0NEREQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMiAxMEgxMVYxM0gyMlYxMFpNMTAgOVYxNEgyM1Y5SDEwWiIgZmlsbD0iI0M3Q0RERCIvPgo8cGF0aCBkPSJNMTEgMTdIMTRWMjBIMTFWMTdaIiBmaWxsPSIjQzdDREREIi8+CjxwYXRoIGQ9Ik0xMSAxNUgyMlYxNkgxMVYxNVoiIGZpbGw9IiNDN0NEREQiLz4KPHBhdGggZD0iTTExIDIxSDE0VjI0SDExVjIxWiIgZmlsbD0iI0M3Q0RERCIvPgo8cGF0aCBkPSJNMTUgMTdIMThWMjBIMTVWMTdaIiBmaWxsPSIjQzdDREREIi8+CjxwYXRoIGQ9Ik0xNSAyMUgxOFYyNEgxNVYyMVoiIGZpbGw9IiNDN0NEREQiLz4KPHBhdGggZD0iTTE5IDE3SDIyVjIwSDE5VjE3WiIgZmlsbD0iI0M3Q0RERCIvPgo8cGF0aCBkPSJNMTkgMjFIMjJWMjRIMTlWMjFaIiBmaWxsPSIjQzdDREREIi8+Cjwvc3ZnPgo=";